// src/Pages/Trabajador/pacientes.jsx
import React from "react";
import { PacientesAdminShared } from "../Admin/pacientes";

export default function PacientesTrabajadorPage() {
  // Este componente ya sabe filtrar por rol === "worker"
  // y mostrar solo los pacientes del kinesiólogo.
  return <PacientesAdminShared />;
}
